function* idGenerator(sid = 1) {
  let id = sid;
  while (42) {
    yield id;
    id += 1;
  }
}

export default idGenerator;
